const accountSelector = {
  label: "Select an account",
};

export default accountSelector;
